import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-right" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-right" }
const _hoisted_4 = { class: "text-right" }
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = { style: {"font-weight":"bold"} }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-right" }
const _hoisted_9 = { class: "text-right" }
const _hoisted_10 = { class: "text-right" }
const _hoisted_11 = { class: "text-left" }
const _hoisted_12 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_DoughnutChart = _resolveComponent("DoughnutChart")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-center"
      }, {
        default: _withCtx(() => [
          (_ctx.clients)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_combobox, {
                    modelValue: _ctx.accountingClient,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.accountingClient) = $event)),
                    items: _ctx.clients,
                    outlined: "",
                    dense: "",
                    "hide-details": "",
                    onChange: _ctx.resetDisplay,
                    class: "pr-2",
                    "item-title": (item) => item.name
                  }, null, 8, ["modelValue", "items", "onChange", "item-title"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.updateLoading)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                cols: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.invoiceId,
                    "onUpdate:modelValue": [
                      _cache[1] || (_cache[1] = ($event: any) => ((_ctx.invoiceId) = $event)),
                      _ctx.resetDisplay
                    ],
                    items: _ctx.invoices,
                    "item-value": "id",
                    outlined: "",
                    "hide-details": "",
                    density: "compact",
                    "item-title": (item) => item.title
                  }, null, 8, ["modelValue", "items", "onUpdate:modelValue", "item-title"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-center"
      }, {
        default: _withCtx(() => [
          (_ctx.updateLoading)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    color: "primary",
                    class: "mr-3"
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-center"
      }, {
        default: _withCtx(() => [
          (!_ctx.updateLoading)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  (_ctx.invoiceId)
                    ? (_openBlock(), _createBlock(_component_v_card, {
                        key: 0,
                        class: "default_card",
                        elevation: "0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, {
                            "no-gutters": "",
                            class: "py-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "9",
                                class: "px-2 headline"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.title), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "3",
                                class: "d-flex px-2 justify-end align-center"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.invoiceId && !_ctx.invoiceId.startsWith('date#'))
                                    ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                        key: 0,
                                        icon: "$oss-download",
                                        class: "mr-2",
                                        onClick: _withModifiers(_ctx.download, ["stop"]),
                                        size: "small"
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_btn_toggle, {
                                    modelValue: _ctx.displayType,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.displayType) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        value: 'chart',
                                        icon: "$fa-chart-pie"
                                      }),
                                      _createVNode(_component_v_btn, {
                                        value: 'table',
                                        icon: "$fa-list-ul"
                                      }),
                                      _createVNode(_component_v_btn, {
                                        value: 'priceList',
                                        icon: "$fa-list-ul"
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_window, {
                                    modelValue: _ctx.displayType,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.displayType) = $event)),
                                    touchless: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_window_item, { value: 'priceList' }, {
                                        default: _withCtx(() => [
                                          (_ctx.clientPriceList && _ctx.clientPriceList.prices)
                                            ? (_openBlock(), _createBlock(_component_v_row, {
                                                key: 0,
                                                class: "d-flex justify-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "12" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_data_table, {
                                                        headers: _ctx.priceListHeaders,
                                                        items: _ctx.clientPriceList.prices,
                                                        "fixed-header": true,
                                                        "virtual-scroll": true,
                                                        class: "table elevation-0"
                                                      }, {
                                                        item: _withCtx((props) => [
                                                          _createElementVNode("tr", null, [
                                                            _createElementVNode("td", null, _toDisplayString(props.item.invoiceProduct.title ||
                                                                "XXX"), 1),
                                                            _createElementVNode("td", _hoisted_1, _toDisplayString(props.item.invoiceProduct.unitPrice), 1)
                                                          ])
                                                        ]),
                                                        _: 1
                                                      }, 8, ["headers", "items"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_window_item, { value: 'chart' }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", {
                                            style: _normalizeStyle(
                                            _ctx.$vuetify.display.mobile
                                                ? 'width: 100%; height: 100%;'
                                                : 'width: 100%; height: 350px;'
                                        )
                                          }, [
                                            (_ctx.statsBilling)
                                              ? (_openBlock(), _createBlock(_component_DoughnutChart, {
                                                  key: 0,
                                                  data: _ctx.statsBilling,
                                                  options: {
                                                plugins: {
                                                    legend: {
                                                        display: _ctx.$vuetify.display.mobile
                                                            ? false
                                                            : true,
                                                        position: 'bottom',
                                                    },
                                                },
                                                maintainAspectRatio: false,
                                                responsive: true,
                                            }
                                                }, null, 8, ["data", "options"]))
                                              : _createCommentVNode("", true)
                                          ], 4),
                                          _createElementVNode("div", {
                                            class: "d-flex headline justify-center align-center",
                                            style: _normalizeStyle(
                                            _ctx.$vuetify.display.mobile
                                                ? 'margin-top: -226px; height: 200px;'
                                                : 'margin-top: -376px; height: 350px;'
                                        )
                                          }, [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalAmountHT, undefined)), 1)
                                          ], 4)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_window_item, { value: 'table' }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_expansion_panels, {
                                            accordion: "",
                                            flat: "",
                                            modelValue: _ctx.panel,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.panel) = $event))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_expansion_panel, {
                                                readonly: "",
                                                style: {"background":"transparent"}
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_expansion_panel_title, {
                                                    class: "primary--text",
                                                    "expand-icon": ""
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_row, {
                                                        "no-gutters": "",
                                                        class: "pr-5"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_col, { cols: "4" }),
                                                          _createVNode(_component_v_col, { cols: "2" }, {
                                                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                              _createElementVNode("strong", null, "Quantité", -1)
                                                            ])),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_v_col, {
                                                            cols: "2",
                                                            class: "d-flex justify-end"
                                                          }, {
                                                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                                                              _createElementVNode("strong", null, "Prix unitaire", -1)
                                                            ])),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_v_col, {
                                                            cols: "2",
                                                            class: "d-flex justify-end"
                                                          }, {
                                                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                                                              _createElementVNode("strong", null, "Prix HT", -1)
                                                            ])),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_v_col, {
                                                            cols: "2",
                                                            class: "d-flex justify-end pr-2"
                                                          }, {
                                                            default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                              _createElementVNode("strong", null, "Prix TTC", -1)
                                                            ])),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lines, (line, i) => {
                                                return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                                                  key: i,
                                                  disabled: line.product.title.startsWith('Forfait'),
                                                  style: {"background":"transparent"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_expansion_panel_title, { class: "primary--text" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_row, {
                                                          "no-gutters": "",
                                                          class: _normalizeClass(
                                                        line.product.title.startsWith('Forfait')
                                                            ? 'pr-5'
                                                            : ''
                                                    )
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, { cols: "4" }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.getProductTitle(line.product)), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            (_ctx.panel !== i + 1)
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                  _createVNode(_component_v_col, { cols: "2" }, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode(_toDisplayString(line.quantity), 1)
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024),
                                                                  _createVNode(_component_v_col, {
                                                                    cols: "2",
                                                                    class: "d-flex justify-end"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    line.unitPrice,
                                                                    undefined,
                                                                )), 1)
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024),
                                                                  _createVNode(_component_v_col, {
                                                                    cols: "2",
                                                                    class: "d-flex justify-end"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    line.unitPrice * line.quantity,
                                                                    undefined,
                                                                )), 1)
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024),
                                                                  _createVNode(_component_v_col, {
                                                                    cols: "2",
                                                                    class: "d-flex justify-end pr-2"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    (line.unitPrice +
                                                                        line.unitPrice *
                                                                            (line.product.vatRate /
                                                                                100)) *
                                                                        line.quantity,
                                                                    undefined,
                                                                )), 1)
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024)
                                                                ], 64))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["class"])
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_expansion_panel_text, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_card, {
                                                          class: "inside_card rounded-xl",
                                                          elevation: "0",
                                                          style: {"overflow":"hidden"}
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_row, {
                                                              "no-gutters": "",
                                                              class: "d-flex justify-center"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_col, { cols: "12" }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_oss_data_table, {
                                                                      headers: _ctx.headers,
                                                                      items: _ctx.getClients(line.product.id),
                                                                      "fixed-header": true,
                                                                      "virtual-scroll": true,
                                                                      class: "table elevation-0"
                                                                    }, {
                                                                      item: _withCtx((props) => [
                                                                        _createElementVNode("tr", null, [
                                                                          _createElementVNode("td", null, _toDisplayString(props.item[0]
                                                                                    .accountingFirmClient
                                                                                    .client.name), 1),
                                                                          _createElementVNode("td", _hoisted_2, _toDisplayString(props.item.length), 1),
                                                                          _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                    line.unitPrice,
                                                                                    undefined,
                                                                                )), 1),
                                                                          _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                    line.unitPrice *
                                                                                        props.item
                                                                                            .length,
                                                                                    undefined,
                                                                                )), 1),
                                                                          _createElementVNode("td", _hoisted_5, [
                                                                            _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                    (line.unitPrice +
                                                                                        line.unitPrice *
                                                                                            (line
                                                                                                .product
                                                                                                .vatRate /
                                                                                                100)) *
                                                                                        props.item
                                                                                            .length,
                                                                                    undefined,
                                                                                )), 1)
                                                                          ])
                                                                        ])
                                                                      ]),
                                                                      "body.append": _withCtx(() => [
                                                                        _createElementVNode("tr", _hoisted_6, [
                                                                          _cache[11] || (_cache[11] = _createElementVNode("td", null, [
                                                                            _createElementVNode("strong", null, "Total")
                                                                          ], -1)),
                                                                          _createElementVNode("td", _hoisted_7, _toDisplayString(line.quantity), 1),
                                                                          _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                    line.unitPrice,
                                                                                    undefined,
                                                                                )), 1),
                                                                          _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                    line.unitPrice *
                                                                                        line.quantity,
                                                                                    undefined,
                                                                                )), 1),
                                                                          _createElementVNode("td", _hoisted_10, [
                                                                            _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                    (line.unitPrice +
                                                                                        line.unitPrice *
                                                                                            (line
                                                                                                .product
                                                                                                .vatRate /
                                                                                                100)) *
                                                                                        line.quantity,
                                                                                    undefined,
                                                                                )), 1)
                                                                          ]),
                                                                          _cache[12] || (_cache[12] = _createElementVNode("td", { class: "text-center" }, null, -1))
                                                                        ])
                                                                      ]),
                                                                      _: 2
                                                                    }, 1032, ["headers", "items"])
                                                                  ]),
                                                                  _: 2
                                                                }, 1024)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["disabled"]))
                                              }), 128)),
                                              _createVNode(_component_v_expansion_panel, {
                                                readonly: "",
                                                style: {"background":"transparent"}
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_expansion_panel_title, {
                                                    class: "primary--text",
                                                    "expand-icon": ""
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_row, {
                                                        "no-gutters": "",
                                                        class: "pr-5"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_col, { cols: "4" }, {
                                                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                                                              _createElementVNode("strong", null, "Total", -1)
                                                            ])),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_v_col, { cols: "2" }),
                                                          _createVNode(_component_v_col, { cols: "2" }),
                                                          _createVNode(_component_v_col, {
                                                            cols: "2",
                                                            class: "d-flex justify-end"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                                _ctx.totalAmountHT,
                                                                undefined,
                                                            )), 1)
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_v_col, {
                                                            cols: "2",
                                                            class: "d-flex justify-end pr-2"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                _ctx.totalAmountTTC,
                                                                undefined,
                                                            )), 1)
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_oss_dialog, {
        title: 'Mois facturé(s)',
        modelValue: _ctx.clientDetailDialog,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.clientDetailDialog) = $event)),
        onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clientDetailDialog = false)),
        width: "400px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_oss_data_table, {
            headers: _ctx.dateHeaders,
            items: _ctx.selectedClientData,
            "fixed-header": true,
            "virtual-scroll": true,
            class: "table elevation-0"
          }, {
            item: _withCtx((props) => [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.month(props.item.date)), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.year(props.item.date)), 1)
              ])
            ]),
            _: 1
          }, 8, ["headers", "items"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}